import { createAction } from './core';
// PUBLIC API
export const updateCurrentUserLastActiveTimestamp = createAction('operations/update-current-user-last-active-timestamp', ['User']);
// PUBLIC API
export const updateCurrentUserNewsletterPreferences = createAction('operations/update-current-user-newsletter-preferences', ['User']);
// PUBLIC API
export const updateCurrentUserAboutMe = createAction('operations/update-current-user-about-me', ['User']);
// PUBLIC API
export const updateFollowedCategories = createAction('operations/update-followed-categories', ['User']);
// PUBLIC API
export const updateUserIsAdminById = createAction('operations/update-user-is-admin-by-id', ['User']);
// PUBLIC API
export const updateArticleSentiment = createAction('operations/update-article-sentiment', ['Article']);
// PUBLIC API
export const deleteArticles = createAction('operations/delete-articles', ['Article', 'Bookmark', 'ArticleLike']);
// PUBLIC API
export const createRssFeed = createAction('operations/create-rss-feed', ['RssFeed']);
// PUBLIC API
export const updateRssFeed = createAction('operations/update-rss-feed', ['RssFeed']);
// PUBLIC API
export const deleteRssFeed = createAction('operations/delete-rss-feed', ['RssFeed']);
// PUBLIC API
export const bootstrapRssFeeds = createAction('operations/bootstrap-rss-feeds', ['RssFeed']);
// PUBLIC API
export const clearArticleFlags = createAction('operations/clear-article-flags', ['Article', 'ArticleFlag']);
// PUBLIC API
export const hideArticle = createAction('operations/hide-article', ['Article']);
// PUBLIC API
export const createPublicationDraft = createAction('operations/create-publication-draft', ['Publication', 'Article']);
// PUBLIC API
export const savePublicationDraft = createAction('operations/save-publication-draft', ['Publication']);
// PUBLIC API
export const publishPublication = createAction('operations/publish-publication', ['Publication']);
// PUBLIC API
export const updateInboxMessageState = createAction('operations/update-inbox-message-state', ['ContactFormMessage']);
// PUBLIC API
export const generateCheckoutSession = createAction('operations/generate-checkout-session', ['User']);
// PUBLIC API
export const unsubscribeFromNewsletter = createAction('operations/unsubscribe-from-newsletter', ['User']);
// PUBLIC API
export const initiateNewsletterSubscription = createAction('operations/initiate-newsletter-subscription', ['User']);
// PUBLIC API
export const confirmNewsletterSubscription = createAction('operations/confirm-newsletter-subscription', ['User']);
// PUBLIC API
export const toggleBookmark = createAction('operations/toggle-bookmark', ['Bookmark']);
// PUBLIC API
export const setArticleLike = createAction('operations/set-article-like', ['ArticleLike']);
// PUBLIC API
export const setArticleFlag = createAction('operations/set-article-flag', ['Article', 'ArticleFlag']);
// PUBLIC API
export const deleteAccount = createAction('operations/delete-account', ['User']);
// PUBLIC API
export const createDiscussion = createAction('operations/create-discussion', ['Discussion']);
// PUBLIC API
export const toggleDiscussionLike = createAction('operations/toggle-discussion-like', ['Discussion', 'DiscussionLike']);
// PUBLIC API
export const createDiscussionView = createAction('operations/create-discussion-view', ['Discussion', 'DiscussionView']);
// PUBLIC API
export const createComment = createAction('operations/create-comment', ['DiscussionComment']);
// PUBLIC API
export const toggleCommentLike = createAction('operations/toggle-comment-like', ['DiscussionComment', 'DiscussionLike']);
//# sourceMappingURL=index.js.map